export enum EmailField {
    ADDRESS = "address"
}

export type Email = {
    [EmailField.ADDRESS]: string,
}